import { BotIcon, BotMessageSquareIcon, UserRoundIcon } from "lucide-react";

import { Row, Column, Text } from "@/components";
import { InternalSourceBadge } from "@/components/InternalSourceBadge";
import { JobTitleAndCompanyName } from "@jobs/pipeline/shared/JobTitleAndCompanyName";
import { StevieCallIndicators } from "@jobs/pipeline/shared/StevieCallIndicators";
import { TableCell } from "@/components/ui/table";

import { formatting } from "@/lib/formatting";
import { misc } from "@/lib/misc";
import { stevieRoute } from "@/lib/stevieRoute";
import { MinimalCandidacy } from "@/types";

export const CandidateCell = ({
  candidacy,
  showCommunicationModeIcon = false,
}: {
  candidacy: MinimalCandidacy;
  showCommunicationModeIcon?: boolean;
}) => {
  const fullName = misc.toTitleCase(
    formatting.fullName(candidacy.firstName, candidacy.lastName, ""),
  );

  /* Render */
  const renderCommunicationModeIcon = () => {
    if (!showCommunicationModeIcon) return null;
    if (candidacy.stafferAgentActive) {
      return (
        <BotMessageSquareIcon className="h-3.5 w-3.5 shrink-0 text-slate-500" />
      );
    }
    if (stevieRoute.isShortlistedViaStevie(candidacy)) {
      return <BotIcon className="h-3.5 w-3.5 shrink-0 text-primary-700" />;
    }
    return <UserRoundIcon className="h-3.5 w-3.5 shrink-0 text-primary-700" />;
  };

  const render = () => (
    <TableCell className="py-3">
      <Column className="gap-0.5">
        <Row className="min-w-0 items-center gap-1">
          <Text className="font-semibold text-slate-900" truncate>
            {fullName}
          </Text>
          {renderCommunicationModeIcon()}
          <InternalSourceBadge source={candidacy.source} isIconOnly />
          <StevieCallIndicators
            currentScore={candidacy.agenticScores[0]?.toScore ?? null}
            elevatedFrom={candidacy.elevatedFrom}
            stevieCallDuration={candidacy.stevieCallDuration}
          />
        </Row>
        <JobTitleAndCompanyName
          companyName={candidacy.mostRecentCompanyName}
          jobTitle={candidacy.mostRecentJobTitle}
        />
      </Column>
    </TableCell>
  );

  return render();
};
